import React from "react";
import TOCModuleSubtopic from "../TOCModuleSubtopic";

const ModuleSubtopicPumpingLemmaCFL = () => (
  <TOCModuleSubtopic
    title="Pumping Lemma for CFL"
    videos={[
      "https://www.youtube.com/embed/nnyHfZssTWA",
      "https://www.youtube.com/embed/-Jo0sQumWzk",
      "https://www.youtube.com/embed/gDYhxGvG1Jw",
      "https://www.youtube.com/embed/c1ph0MgYQ-0",
      "https://www.youtube.com/embed/ww4m4UJTbWE",
    ]}
    takeaways={[
      {
        text: "Almost direct questions appear in exams. If asked whether a language is Context-Free (CFG) or not, in most cases, the language is not CFG. Prove this using the Pumping Lemma.",
      },
    ]}
    questions={[
      {
        text: "Given that the language L={z#x | z is a substring of x, where z,x ∈{a,b}*}. Prove that L is not a context-free language.",
      },
    ]}
    exampleVideos={[]} // Add example question videos if needed
  />
);

export { ModuleSubtopicPumpingLemmaCFL };
